import { useState } from 'react';
import { Menu } from 'lucide-react';
import { Outlet } from 'react-router-dom';
import { LiksBrand } from '../components/liks/LiksBrand/LiksBrand';
import { LiksErrorBoundary } from '../components/liks/LiksErrorBoundary/LiksErrorBoundary';
import { LiksIconButton } from '../components/liks/LiksIconButton/LiksIconButton';
import { LiksSidebar } from '../components/liks/LiksSidebar/LiksSidebar';
import { LiksToaster } from '../components/liks/LiksToaster/LiksToaster';
import { useTenantLogoSrc } from '../features/tenant/hooks/useTenantLogoSrc';
import { useI18n } from '../i18n/useI18n';
import { SIDEBAR_NAV_ITEMS } from '../components/liks/LiksSidebar/sidebarNavItems';
import { useIsDesktop } from '../hooks/useMediaQuery';
import './AppLayout.css';

export function AppLayout() {
  const { translate } = useI18n();
  const isDesktop = useIsDesktop();
  const tenantLogoSrc = useTenantLogoSrc();
  const [isExpanded, setIsExpanded] = useState(true);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return (
    <div className="app-layout">
      <LiksSidebar
        items={SIDEBAR_NAV_ITEMS}
        isDesktop={isDesktop}
        isExpanded={isExpanded}
        isOpen={isMobileOpen}
        onExpand={() => setIsExpanded(true)}
        onCollapse={() => setIsExpanded(false)}
        onClose={() => setIsMobileOpen(false)}
      />

      <div className="app-layout__content">
        {!isDesktop && (
          <header className="app-layout__header">
            <LiksIconButton
              variant="on-light"
              aria-label={translate('layout.openMenu')}
              onClick={() => setIsMobileOpen(true)}
            >
              <Menu strokeWidth={2} aria-hidden />
            </LiksIconButton>
            <LiksBrand
              className="app-layout__brand"
              logoSrc={tenantLogoSrc ?? undefined}
            />
          </header>
        )}

        <main className="app-layout__main">
          <LiksErrorBoundary variant="inset" showGoHome>
            <Outlet />
          </LiksErrorBoundary>
        </main>

        <LiksToaster />
      </div>
    </div>
  );
}
